import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RideDriverDetailScreen from './screens/RideDriverDetailScreen';
import RideDriversListScreen from './screens/RideDriversListScreen';

function RideDrivers() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RideDriversListScreen />} />
          <Route path=":driverProfileId" element={<RideDriverDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RideDrivers;
